(function () {
  'use strict';

  if (window.BKV293Wishlist) {
    window.BKV293Wishlist.sync();
    return;
  }

  const STORAGE_KEY = 'wishlistItem';
  const LEGACY_KEY = 'bk_wishlist';
  const documentLanguage = (document.documentElement.lang || '').toLowerCase();
  const isArabic = documentLanguage.startsWith('ar');
  const labels = {
    add: isArabic ? 'أضيفي إلى المفضلة' : 'Add to wishlist',
    remove: isArabic ? 'إزالة من المفضلة' : 'Remove from wishlist'
  };

  function read(key) {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function normalizeHandle(value) {
    const raw = typeof value === 'string' ? value : value?.handle;
    return String(raw || '').replace(/-\d{8,}$/, '').trim();
  }

  function list() {
    return Array.from(new Set(read(STORAGE_KEY).map(normalizeHandle).filter(Boolean)));
  }

  function save(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(new Set(handles.map(normalizeHandle).filter(Boolean)))));
  }

  function migrate() {
    const nativeHandles = list();
    const legacyHandles = read(LEGACY_KEY).map(normalizeHandle).filter(Boolean);
    if (legacyHandles.length) save(nativeHandles.concat(legacyHandles));
    else if (localStorage.getItem(STORAGE_KEY) === null) save(nativeHandles);
    if (localStorage.getItem(LEGACY_KEY) !== null) localStorage.removeItem(LEGACY_KEY);
  }

  function setButtonState(button, saved) {
    const label = saved ? labels.remove : labels.add;
    button.classList.toggle('wishlist-added', saved);
    button.classList.toggle('is-active', saved);
    button.setAttribute('aria-pressed', String(saved));
    button.setAttribute('aria-label', label);
    button.title = label;
    button.querySelectorAll('.text, [data-wishlist-label], [data-bk-wishlist-label]').forEach((element) => {
      element.textContent = label;
    });
    const tooltip = button.closest('.na-icon-wrapper, .bk-icon-wrapper')?.querySelector('.na-tooltip, .bk-tooltip');
    if (tooltip) tooltip.textContent = label;
  }

  function sync() {
    const handles = new Set(list());
    document.querySelectorAll('[data-wishlist][data-wishlist-handle]').forEach((button) => {
      setButtonState(button, handles.has(normalizeHandle(button.dataset.wishlistHandle)));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = String(handles.size);
    });
  }

  function toggle(handle) {
    const handles = list();
    const index = handles.indexOf(handle);
    const saved = index < 0;
    if (saved) handles.push(handle);
    else handles.splice(index, 1);
    save(handles);
    sync();
    document.dispatchEvent(new CustomEvent(saved ? 'addwishlistitem' : 'removewishlistitem', {
      bubbles: true,
      detail: { handle }
    }));
    document.dispatchEvent(new CustomEvent('bkwishlistchange', { bubbles: true, detail: { handle, saved } }));
  }

  migrate();
  sync();

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist][data-wishlist-handle]');
    if (!button) return;
    if (window.wishlist?.show && !button.hasAttribute('data-bk-v293-wishlist')) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = normalizeHandle(button.dataset.wishlistHandle);
    if (handle) toggle(handle);
  }, true);

  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('bkwishlistchange', sync);
  window.addEventListener('pageshow', sync);
  window.addEventListener('popstate', sync);
  window.BKV293Wishlist = { list, sync, toggle };
})();
